/**
 * 登录注册弹框
 */
import { useEffect, useState } from 'react';

let loginDialog: any = null;
let visiblePreperty: any = null;
export function useLoginModal(loginSuccessCb: () => void) {
  // const [loginDialog, setLoginDialog] = useState<any>(null);
  // const [visiblePreperty, setVisibleProperty] = useState<string>();

  // 打开登录弹框
  const openLoginModal = () => {
    if (loginDialog && visiblePreperty) {
      loginDialog.setProperty(visiblePreperty, true);
    }
  };
  // 关闭登录注册弹框
  const closeLoginModal = () => {
    if (loginDialog && visiblePreperty) {
      loginDialog.setProperty(visiblePreperty, false);
    }
  };

  useEffect(() => {
    if (loginDialog) {
      return;
    }
    window.BybitUniFrame?.ready?.(({ loginModal }: { loginModal: any }) => {
      loginModal.init().then((_login: any) => {
        const { LOGIN_SUCCESS, HIDE_MODAL } = _login.events;
        const { VISIBLE } = _login.properties;
        _login
          .subscribeEvent(HIDE_MODAL, () => {
            closeLoginModal();
          })
          .subscribeEvent(LOGIN_SUCCESS, () => {
            closeLoginModal();
            loginSuccessCb();
          });

        // setLoginDialog(_login);
        // setVisibleProperty(VISIBLE);
        loginDialog = _login;
        visiblePreperty = VISIBLE;
      });
    });
    return () => {
      loginDialog?.dealloc();
    };
  }, []);

  return {
    openLoginModal,
    closeLoginModal,
  };
}
